export default function EndNode() {
    return (
        <div className="milestone-container">
            <div className="node end-node"></div>
        </div>
    )
}